// extracted by mini-css-extract-plugin
module.exports = {"wound-details-heading":"style_wound-details-heading__1P_qs","sub-title":"style_sub-title__2HJ2o","badge":"style_badge__2fPIb","icon-small":"style_icon-small__2v1bO"};